var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMembership(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50001 2.75C5.22649 2.75 4.97466 2.8989 4.84284 3.13856L2.09284 8.13856C1.94446 8.40835 1.97604 8.74142 2.17249 8.97851L9.42249 17.7285C9.56498 17.9005 9.77668 18 10 18C10.2233 18 10.435 17.9005 10.5775 17.7285L17.8275 8.97851C18.024 8.74142 18.0556 8.40835 17.9072 8.13856L15.1572 3.13856C15.0254 2.8989 14.7735 2.75 14.5 2.75H5.50001ZM4.15596 7.5L5.94346 4.25H7.44287L6.30537 7.5H4.15596ZM6.14357 9L8.07254 13.7482L4.13829 9H6.14357ZM9.9893 14.481L7.76262 9H12.1485L9.9893 14.481ZM7.89459 7.5L9.03209 4.25H10.9771L12.1745 7.5H7.89459ZM13.773 7.5L12.5756 4.25H14.0566L15.8441 7.5H13.773ZM13.7607 9H15.8617L11.8564 13.834L13.7607 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembership);
export default __webpack_public_path__ + "static/media/membership.d781194ed2775592ae7d21462e07465d.svg";
export { ForwardRef as ReactComponent };